import { subscribeForOfferRequest } from '../../../api/subscribe';
import { sendUsersClaims } from '../../../api/user_claims';
import { IApplicationState } from '../../../di/store';
import { createActionCreator } from '../../../utils/fsa';
import { waitAtLeast } from '../../../utils/superagent';
import { trackFormError, trackFormSent } from '../tracking';
import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';

interface IData {
  email: string;
  name: string;
  phone: string;
  text: string;
  captcha: string;
  oid: string;
  subscribe?: boolean;
}

export interface IActionUserClaimsData {
  oid: string;
  isPIK: boolean;
  subscribeAbGroup: number;
  offerRequestReferer: string | void;
}

export const formSent =
  createActionCreator<{}>('user_claims/form_sent');

export const formError =
  createActionCreator<{ error: Error }>('user_claims/form_error');

export const setUserClaimsData =
  createActionCreator<IActionUserClaimsData>('user_claims/data');

export const onSubmitForm = (data: IData): ThunkAction<Promise<void>, IApplicationState, void> =>
  (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState) => {
    const { subscribeAbGroup, offerRequestReferer } = getState().userClaims;

    if (subscribeAbGroup === 1 && offerRequestReferer && data.subscribe) {
      subscribeForOfferRequest(offerRequestReferer, data.email, subscribeAbGroup);
    }

    return waitAtLeast(500, sendUsersClaims({
      type: 'additionalInfoRequest',
      message: data.text,
      contacts: {
        email: data.email,
        firstName: data.name,
        phoneNumber: data.phone,
      },
      offerInfo: {
        price: {},
        offerId: data.oid,
      },
      contactTime: {
        fromTime: null,
        toTime: null,
      },
      captcha: data.captcha,
    })).then((res) => {
      trackFormSent();
      dispatch(formSent({}));
    }).catch((error) => {
      trackFormError();
      dispatch(formError({
        error,
      }));
    });
  };

export function submitForm(dispatch: Dispatch<IData>, data: IData): Promise<void> {
  return waitAtLeast(500, sendUsersClaims({
    type: 'additionalInfoRequest',
    message: data.text,
    contacts: {
      email: data.email,
      firstName: data.name,
      phoneNumber: data.phone,
    },
    offerInfo: {
      price: {},
      offerId: data.oid,
    },
    contactTime: {
      fromTime: null,
      toTime: null,
    },
    captcha: data.captcha,
  })).then((res) => {
    trackFormSent();
    dispatch(formSent({}));
  }).catch((error) => {
    trackFormError();
    dispatch(formError({
      error,
    }));
  });
}



// WEBPACK FOOTER //
// ./src/bundles/user_claims/action_creators/user_claims.ts